import { render } from "./LocationAndWorkplace.vue?vue&type=template&id=fac45a80&scoped=true&ts=true"
import script from "./LocationAndWorkplace.vue?vue&type=script&lang=ts"
export * from "./LocationAndWorkplace.vue?vue&type=script&lang=ts"

import "./LocationAndWorkplace.vue?vue&type=style&index=0&id=fac45a80&scoped=true&lang=scss"
import "./LocationAndWorkplace.vue?vue&type=style&index=1&id=fac45a80&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac45a80"]])

export default __exports__